var map = {
	"./de.json": [
		1841,
		2
	],
	"./de_CH.json": [
		1882,
		63
	],
	"./en.json": [
		656
	],
	"./en_CA.json": [
		1883,
		1
	],
	"./en_CH.json": [
		1884,
		0
	],
	"./en_GB.json": [
		1885,
		0
	],
	"./fr.json": [
		1886,
		64
	],
	"./fr_CA.json": [
		1887,
		8
	],
	"./fr_CH.json": [
		1888,
		1
	],
	"./it.json": [
		1889,
		65
	],
	"./it_CH.json": [
		1842,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 766;
module.exports = webpackAsyncContext;